"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeItem = void 0;
/**
 * 指定した要素を削除して、削除後の配列を非破壊で返す。
 */
const removeItem = (original, target) => {
    return original.filter((i) => i !== target);
};
exports.removeItem = removeItem;
//# sourceMappingURL=removeItem.js.map